import { render, staticRenderFns } from "./Manuel.vue?vue&type=template&id=558b8006&"
import script from "./Manuel.vue?vue&type=script&lang=js&"
export * from "./Manuel.vue?vue&type=script&lang=js&"
import style0 from "./Manuel.vue?vue&type=style&index=0&id=558b8006&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
